'use strict';

import main from './lib/MlbLinker';

export default main;

